import PropTypes from 'prop-types'

import { BrakePerformance } from '../../models/ebs/brake-performance-enum.js'
import { iso8601PropType } from '../common/iso-8601-prop-type'

const { BRAKE_EVENTS, PERFORMANCE, STATUS, TIMESTAMP } = BrakePerformance

/**
 * @typedef {Object} BrakePerformance
 *
 * @property {number} [brakeEvents]     - The brake events value of the brake performance
 * @property {number} [performance]     - The performance value of the brake performance
 * @property {ISO8601} [timestamp]      - The date and time of the brake performance
 * @property {string} [status]          - The status of the brake performance
 */
export const brakePerformancePropType = PropTypes.shape({
    [BRAKE_EVENTS]: PropTypes.number,
    [PERFORMANCE]: PropTypes.number,
    [TIMESTAMP]: iso8601PropType,
    [STATUS]: PropTypes.string
})
